import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { FormInputComponent } from './form-input.component';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule, PopoverModule],
    exports: [FormInputComponent],
    declarations: [FormInputComponent]
})
export class FormInputModule {}
